

module.exports = function($) {

    return {
        init: init
    };

    function init() {
        initCharacterCounter();
        initTooltips();
    }

    function initTooltips() {
        $(document).tooltip({
            content: function() {
                return $(this).prop('title');
            },
        });
    }

    function initCharacterCounter() {
        var counterParent = $('.js-display-max-length');

        $.each(counterParent, function() {
            var counterElement = $('textarea', this);
            var maxLength = counterElement.attr('maxlength');
            var self = this;

            $(counterElement).on('input', function() {
                outputCount(self, this.value.length, maxLength);
            });

            outputCount(this, 0, maxLength);
        });

        function outputCount(el, count, max) {
            var initialOutput = '<p class="counter">';
            initialOutput += count + '/' + max;
            initialOutput += '</p>';

            var existingOutput = $('p.counter', el);

            if (!existingOutput.length) {
                $(el).append(initialOutput);
            } else {
                existingOutput.html(count + '/' + max);
            }

            // add warning class when close to max
            if (max - count <= 20) {
                existingOutput.addClass('counter--warning');
            }
            // remove when not too close
            if (max - count > 20) {
                existingOutput.removeClass('counter--warning');
            }
        }
    }
};
